export default __webpack_public_path__ + "static/booth-a9044b66b22f6c1adbc1e97b1d93f171.png";